var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"e73785d0b845b08a3fcbc398be56202b4417f676"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["policy-expert-site@qmetric"]={id:"e73785d0b845b08a3fcbc398be56202b4417f676"};
      